import { render, staticRenderFns } from "./public-spell.vue?vue&type=template&id=d54ac5d8&scoped=true&"
import script from "./public-spell.vue?vue&type=script&lang=js&"
export * from "./public-spell.vue?vue&type=script&lang=js&"
import style0 from "./public-spell.vue?vue&type=style&index=0&id=d54ac5d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54ac5d8",
  null
  
)

export default component.exports